export default __webpack_public_path__ + "static/media/two.b89a301f.jpg";